import styles from './index.module.scss'
import { Button, Input, message, Modal, Popover } from 'antd'
import { LeftOutlined, RightOutlined, CheckOutlined } from '@ant-design/icons'
import { useCallback, useEffect, useState } from 'react'
import Utils from '@utils/utils'
import API, { commonApiInvoker } from "@api/api"

export default function PicViewerBottom ({
    image,
    hasPrev,
    hasNext,
    onPrev,
    onNext,
    onStatusChange,
    onModalOpenChange,
}) {
    const {
        status, // 'approved' | 'rejected' | 'modified' | null
        approveText="可用",
        approvedText="可用",
        rejectText="需修改",
        rejectedText="需修改",
        rejectDisabled=false, // 是否禁用拒绝按钮
        downloadDisabled=true, // 是否禁用下载按钮
        readOnly=false, // 是否只读模式
    } = image
    const [feedbackOpen, setFeedbackOpen] = useState(false)
    const [feedback, setFeedback] = useState()

    // Notify parent about modal state changes
    useEffect(() => {
        onModalOpenChange?.(feedbackOpen)
    }, [feedbackOpen, onModalOpenChange])

    const handleStatusChange = useCallback(async (status) => {
        if (status == "approved" || !status) {
            try {
                await onStatusChange?.(status)
                if (status == "approved" && hasNext) {
                    onNext()
                }
            } catch (err) {
                console.error(err)
            }
        } else {
            setFeedbackOpen(true)
            setFeedback()
        }
    }, [status, onStatusChange, hasNext, onNext])
    const handleFeedbackSubmit = useCallback(async () => {
        try {
            if (!feedback.trim()) return message.warning('请先填写修改要求')
            await onStatusChange?.('rejected', feedback)
            setFeedbackOpen(false)
        } catch (err) {
            console.error(err)
        }
    }, [feedback, onStatusChange])

    const handleDownload = useCallback(() => {
        if (!image) return
        console.log('image', image)
        const url = image.url
        const filename = image.name
        const extension = url.split('?').shift().split('.').pop()
        Utils.downloadUrl(url, filename ? `${filename}.${extension}` : null)
        message.success("图片已下载")
        // // 下载图片埋点
        if (image.id) API.trackImageDownload([image.id])
    }, [image])

    return (
        <div className={styles.PicViewerBottom}>
            <div
                className={`${styles.NavBtn} ${!hasPrev ? styles.disabled : ''}`}
                onClick={hasPrev ? onPrev : undefined}
            >
                <LeftOutlined /> 上一张
            </div>
            {downloadDisabled ? null :
            <div
                className={`${styles.ActionBtn}`}
                style={{cursor: "pointer"}}
                onClick={handleDownload}
            >
                下载
            </div>}
            {rejectDisabled ? null :
            <div
                className={`${styles.ActionBtn} ${styles.Rejected} ${status === 'rejected' ? styles.active : ''}`}
                style={{cursor: readOnly ? "not-allowed" : "pointer"}}
                onClick={readOnly ? undefined : () => handleStatusChange?.(status === 'rejected' ? null : 'rejected')}
            >
                {status == "rejected" ? <CheckOutlined /> : null}
                {status == "rejected" ? rejectedText : rejectText}
            </div>}
            <div
                className={`${styles.ActionBtn} ${styles.Approved} ${(!status || status === 'modified') ? styles.default : status === 'approved' ? styles.active : ''}`}
                style={{cursor: readOnly ? "not-allowed" : "pointer"}}
                onClick={readOnly ? undefined : () => handleStatusChange?.(status === 'approved' ? null : 'approved')}
            >
                {status == "approved" ? <CheckOutlined /> : null}
                {status == "approved" ? approvedText : approveText}
            </div>
            <div
                className={`${styles.NavBtn} ${!hasNext ? styles.disabled : ''}`}
                onClick={hasNext ? onNext : undefined}
            >
                下一张 <RightOutlined />
            </div>
            <Modal
                title="修改要求"
                centered
                open={feedbackOpen}
                onCancel={() => setFeedbackOpen(false)}
                onOk={handleFeedbackSubmit}
                okText="保存"
                cancelText="取消"
            >
                <div className={styles.CommentForm}>
                    <div className={styles.ButtonGroup}>
                        <span>选择【需修改】时，必须填写评论</span>
                    </div>
                    <Input.TextArea
                        placeholder="请详细描述您的修改要求..."
                        style={{ height: 145, resize: 'none', backgroundColor: '#FFF' }}
                        value={feedback}
                        onChange={e => setFeedback(e.target.value)}
                    />
                </div>
            </Modal>
        </div>
    )
}
